<syndicated-header class="header">
</syndicated-header>
<main appUniversalResources>
  <pixie-homepage></pixie-homepage>
  <router-outlet></router-outlet>
</main>
<syndicated-footer class="footer">
</syndicated-footer>
<font-icon-loader></font-icon-loader>
